<div class="columns small-12 medium-8" data-cy="sharedIPSection">
  <p>
    {{ 'internet.settings.shared.ip.description1' | translate }}
    <strong>{{ 'internet.settings.shared.ip.description2' | translate }}</strong>
  </p>
  <button
    class="rs-btn"
    (click)="updateIpSettings()"
    [disabled]="sharedIpSuccess"
    [ngClass]="{ 'rs-btn-disabled': sharedIpSuccess }"
    data-tms-event="button-click"
    attr.data-tms-button-zone="{{ 'internet.settings.shared.ip.title' | translate }}"
    data-tms-button-name="opt for a dedicated ip"
    data-cy="sharedIPButton"
  >
    {{ 'internet.settings.shared.ip.button' | translate }}
  </button>

  <px-alert [alertKey]="'updateSharedIpAlert'" data-cy="updateSharedIpAlert"></px-alert>
</div>
